export default __webpack_public_path__ + "883fc708c103c149b383ededf9867019.png";